import React from 'react';
import styled from 'styled-components';
import { InView } from 'react-intersection-observer';

import Loader from '../Loader';
import ProductCardContainer from '../ProductCard';

const ProductContents = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1;
  width: 100%;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    width: calc(100% + 32px);
    margin-left: -16px;
  }
`;

const ProductWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(50%, 1fr));
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    grid-template-columns: repeat(auto-fill, minmax(33.333%, 1fr));
  }
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.largeTablet}px) {
    grid-template-columns: repeat(auto-fill, minmax(50%, 1fr));
  }
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}px) {
    grid-template-columns: repeat(auto-fill, minmax(33.333%, 1fr));
  }
`;

type ProductDisplayProps = {
  products: Shopify.ProductEdge[];
  canLoadMore: boolean;
  loading: boolean;
  loadMore: () => void;
  titleForTracking?: string;
  query?: string;
};

const ProductsDisplay: React.FC<ProductDisplayProps> = ({
  products,
  canLoadMore,
  loading,
  loadMore,
  titleForTracking,
  query,
}: ProductDisplayProps) => (
  <ProductContents>
    <ProductWrapper>
      {products.map(({ node }) => (
        <div className="p-2.5">
          <ProductCardContainer key={node.id} product={node} titleForTracking={titleForTracking} query={query} />
        </div>
      ))}
    </ProductWrapper>
    {canLoadMore && (
      <InView as="div" onChange={(inView, _) => inView && canLoadMore && loadMore()}>
        {loading && <Loader />}
      </InView>
    )}
  </ProductContents>
);

export default ProductsDisplay;
